// extracted by mini-css-extract-plugin
export default {"notes":"ViewNoteModal_notes__v6I2e","list":"ViewNoteModal_list__l2SEt","note-block":"ViewNoteModal_note-block__e5+6n","title":"ViewNoteModal_title__u1WG4"};